import React from "react";

const NotFound = () => {
  return <h1>éo co</h1>;
};

export default NotFound;
